import { AutogenModelBankAccountLookup, AutogenRowBankAccountLookup } from "./autogen/AutogenModelBankAccountLookup";

export class ModelBankAccountLookup extends AutogenModelBankAccountLookup<RowBankAccountLookup> {
	constructor() {
		super(RowBankAccountLookup);
	}
}

export class RowBankAccountLookup extends AutogenRowBankAccountLookup {
}